import React from 'react';
import {connect} from 'react-redux';
import {get} from 'lodash';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import {SYSTEM_MEASURE} from '../../util/SystemMeasure';
import {getSettings, updateSettings, updateEmailAlert} from '../UserSettingsActions';
import {loadOerTypes} from '../../LibraryFilter/libraryFilterActions';
import SystemMeasure from '../component/SystemMeasure';
import EventVideoAlerts from '../component/EventVideoAlerts';

class UserSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      settings: props.settings
    };
  }

  componentDidMount() {
    const userId = get(this.props, 'user.userInformation.userId', null);
    this.props.getSettings(userId);
    this.props.loadOerTypes({showAll: true});
  }

  componentDidUpdate(prevProps) {
    if (this.props.settings.systemMeasure !== prevProps.settings.systemMeasure) {
      this.updateSystemMeasure();
    }
  }

  updateSystemMeasure = () => {
    this.setState({
      settings: {
        systemMeasure: this.props.settings.systemMeasure
      }
    });
  }

  handleSystemMeasure = ({target}) => {
    const {value} = target;
    this.setState({
      settings: {
        systemMeasure: (value === SYSTEM_MEASURE.IMPERIAL) ? SYSTEM_MEASURE.IMPERIAL : SYSTEM_MEASURE.METRIC
      }
    });
  }

  handleSaveMeasure = () => {
    const userId = get(this.props, 'user.userInformation.userId', null);
    const {settings} = this.state;
    this.props.updateSettings(userId, settings);
  }

  render() {
    const {
      isSavingEmailAlert,
      isSavedEmaiVideolAlert,
      isSaving,
      isSaved,
      isLoading
    } = this.props;

    const {settings} = this.state;

    return (
      <div>
        <Grid container className="admin">
          {isLoading &&
            <div className="dvrcard__progresscont">
              <CircularProgress className="loading__cirgularprogress" size={50} />
            </div>
          }
          <Grid item lg={7} md={10} sm={12} xs={12}>
            {!isLoading &&
              <EventVideoAlerts
                user={this.props.user}
                settings={this.props.settings}
                isSaving={isSavingEmailAlert}
                isSaved={isSavedEmaiVideolAlert}
                oerTypes={this.props.oerTypes}
                updateEmailAlert={this.props.updateEmailAlert}
              />
            }
            {!isLoading &&
              <SystemMeasure
                isSaving={isSaving}
                isSaved={isSaved}
                systemMeasure={settings.systemMeasure}
                onSave={this.handleSaveMeasure}
                onChangeSystemMeasure={this.handleSystemMeasure}
              />
            }
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {userSettings, user} = state;
  const oerTypes = get(state, 'libraryFilters.oerTypes', []);
  
  return {
    oerTypes,
    user,
    ...userSettings,
    ...state.i18n.locale
  };
}

export default connect(mapStateToProps, {
  getSettings,
  updateSettings,
  updateEmailAlert,
  loadOerTypes
})(UserSettings);
